const state = {
  // Список организаторов стартов
  startsOrganizers: [],

  // Системный организатор старта
  systemOrganizer: {},

  // Общее количество e-mail
  totalNumberOfStartsOrganizers: 0,

  // Флаг показывающий загружается ли сейчас страница с организаторами стартов
  isStartsOrganizersLoading: false,
};

export default state;
